<fgb-mobile-header-bar [title]="'polls.page.title' | translate" [showPoints]="true" [link]="'/games'"></fgb-mobile-header-bar>
<div class="game-layout-banner">
  <div class="container" fgbAnimateOnScroll>
    <a class="games-back-btn text-white d-lg-flex d-none" [routerLink]="['/games']">
      <i class="material-icons">chevron_left</i>
      <span>{{ 'games.back.button' | translate }}</span>
    </a>
    <div class="game-banner-img">
      <img src="assets/images/games/PollsBanner.png" alt="" />
    </div>
  </div>
</div>
<div class="mobile-content-wrapper">
  <div class="container mt-lg-4 mt-0">
    <ng-container *ngIf="pollsQuestion$ | async as pollsQuestions; else shimmerEffect">
      <fgbcl-game-polls-question-list [pollsQuestions]="pollsQuestions" (answerSelected)="onAnswerSelected($event)">
      </fgbcl-game-polls-question-list>
    </ng-container>

    <!-- Shimmer Effect -->
    <ng-template #shimmerEffect>
      <div class="skeleton-placeholder predictor">
        <div class="card" aria-hidden="true" *ngFor="let i of [1, 2, 3]">
          <h6 class="card-title placeholder-glow text-center">
            <span class="question-shimmer-effect placeholder col-6"></span>
          </h6>
          <div class="answer-shimmer-effect-section">
            <p class="card-text placeholder-glow w-100 mb-0 text-center">
              <span class="answer-shimmer-effect placeholder col-12"></span>
            </p>
            <p class="card-text placeholder-glow w-100 mb-0 text-center">
              <span class="answer-shimmer-effect placeholder col-12"></span>
            </p>
          </div>
          <div class="answer-shimmer-effect-section mt-3">
            <p class="card-text placeholder-glow w-100 mb-0 text-center">
              <span class="answer-shimmer-effect placeholder col-12"></span>
            </p>
            <p class="card-text placeholder-glow w-100 mb-0 text-center">
              <span class="answer-shimmer-effect placeholder col-12"></span>
            </p>
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <p class="card-text placeholder-glow w-40 text-center">
              <span class="presentby-shimmer-effect placeholder col-7"></span>
            </p>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
